import { mq, Button as _Button } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivFlexContainer = styled.div`
  margin-top: 32px;
`;

export const DivGridButtonSpace = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 16px;

  ${mq.sp} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const Button = styled(_Button)`
  white-space: nowrap;
`;
